const HouseChainIcon = ({ className }: { className: string }) => {
  return (
    <svg
      aria-hidden='true'
      className={className}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M17 22a2 2 0 0 0 2-2V8l-5-4-1 .5'
        stroke='#1A1A1A'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='m18 4 4 3v13c0 1-.5 2-1.5 2M1 9l7-5 7 5v11a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V9Z'
        stroke='#1A1A1A'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5 22v-8h6v8'
        stroke='#1A1A1A'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default HouseChainIcon;
